import request from '@/utils/httpClient'

// 批量删除
export function deleteById(url: string, id: number) {
  return request({
    url: `${url}/${id}`,
    method: 'delete'
  })
}

// 获取详情
export function getDetailById(url: string, id: number, params?: any) {
  return request({
    url: `${url}/${id}`,
    method: 'get',
    params
  })
}

// 获取列表
export function getPageList(url: string, params?: object) {
  return request({
    url: `${url}/page`,
    method: 'get',
    params
  })
}

// 获取下拉数据
export function getDropdown(url: string, params?: object) {
  return request({
    url: `${url}/dropdown`,
    method: 'get',
    params
  })
}

// 获取tree
export function getTree(url: string, params?: object) {
  return request({
    url,
    method: 'get',
    params
  })
}

// 获取跟踪日志
export function getTraceList(url: string, id: number, params?: object) {
  return request({
    url: `${url}/${id}/actions/trace`,
    method: 'get',
    params
  })
}

// 留言
export function traceComment(url: string, id: number, data?: object) {
  return request({
    url: `${url}/${id}/actions/trace`,
    method: 'post',
    data
  })
}

// 通过审批
export function reviewApprove(url: string, id: number, data?: object) {
  return request({
    url: `${url}/${id}/actions/review/approve`,
    method: 'put',
    data
  })
}

// 通过拒绝
export function reviewReject(url: string, id: number, data?: object) {
  return request({
    url: `${url}/${id}/actions/review/reject`,
    method: 'put',
    data
  })
}

export function putUrl(url: string, data?: object) {
  return request({
    url,
    method: 'put',
    data
  })
}

export function postUrl(url: string, data?: object) {
  return request({
    url,
    method: 'post',
    data
  })
}
